const Flickity = require("flickity");
const mixitup = require("mixitup");

(function($) {
  const spiralDrives = {};

  spiralDrives.hamburgerMenu = () => {
    $(".hamburger").on("click", function() {
      $("body").toggleClass("menu-active");

      $(this).toggleClass("is-active");
      $(".nav-mobile").toggleClass("open");
      $(".language-switch").toggleClass("open");
    });
  };

  spiralDrives.subMenu = () => {
    $(".mobile-menu")
      .find(".menu-item-has-children")
      .find("a:first")
      .on("click", function(e) {
        e.preventDefault();

        $(this)
          .closest(".menu-item-has-children")
          .find(".sub-menu")
          .addClass("sub-menu--active");
      });

    $(".mobile-menu")
      .find(".btn-prev")
      .on("click", function(e) {
        e.preventDefault();
        $(this)
          .closest(".sub-menu")
          .removeClass("sub-menu--active");
        e.stopPropagation();
      });
  };

  spiralDrives.partnersFilter = () => {
    const $containerEL = document.querySelector(".filter-partners");

    const $noItemsFoundMessage = document.getElementById("no-items-found");
    $($noItemsFoundMessage).hide();

    if ($containerEL) {
      let mixer = mixitup(".filter-partners", {
        controls: {
          enable: false,
        },

        selectors: {
          target: ".partner-logo"
        },
        animation: {
          duration: 300
        },
        callbacks: {
          onMixEnd: function(state) {
            if (state.hasFailed) {
              $($noItemsFoundMessage).show();
            } else {
              $($noItemsFoundMessage).hide();
            }
          }
        }
      });

      const $logoSelectors = $("#logo-selectors");

      $logoSelectors.on("change", function(e) {

        let strings = [];

        const $selectors = $('.logo-selector');
        const $levelSelector = $selectors.filter('#level');
        const $regularSelectors = $selectors.not('[multiple]');
        const levelValues = $levelSelector.val();

        if(levelValues) {
            strings = levelValues;
        }

        $regularSelectors.each(function() {
            const val = $(this).val();
            if (val) {
              strings.push(val)
            }
        });

        if(strings.length) {
          mixer.filter(strings.join(''));

        } else {
            mixer.filter('all');
        }

      });

      // hides the default select and creates a new one with the same functionalty
      $("select").each(function() {
        const $this = $(this),
          numberOfOptions = $(this).children("option").length;

        $this.addClass("select-hidden");
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        const $styledSelect = $this.next("div.select-styled");
        const emptyText = $this
          .children("option")
          .eq(0)
          .text();
        $styledSelect.text(emptyText);

        const $list = $("<ul />", {
          class: "select-options"
        }).insertAfter($styledSelect);

        for (let i = 0; i < numberOfOptions; i++) {
          $("<li />", {
            text: $this
              .children("option")
              .eq(i)
              .text(),
            rel: $this
              .children("option")
              .eq(i)
              .val()
          }).appendTo($list);
        }

        var $listItems = $list.children("li");

        $styledSelect.on("click", function(e) {
          e.stopPropagation();
          $("div.select-styled.active")
            .not(this)
            .each(function() {
              $(this)
                .removeClass("active")
                .next("ul.select-options")
                .hide();
            });
          $(this)
            .toggleClass("active")
            .next("ul.select-options")
            .toggle();
        });

        $listItems.on("click", function(e) {
          e.stopPropagation();

          if ($this.attr("multiple")) {
            let texts = [];

            if ($(this).attr("rel") !== "") {
              $(this).toggleClass("active");
            } else {
              $listItems.removeClass("active");
              $list.hide();
            }

            const values = $listItems
              .map(function() {
                if ($(this).hasClass("active") && $(this).attr("rel") !== "") {
                  texts.push($(this).text());
                  return $(this).attr("rel");
                }
              })
              .get();

            if (texts.length) {
              $styledSelect.text(texts.join(", "));
            } else {
              $styledSelect.text(emptyText).removeClass("active");
            }

            $this.val(values).trigger("change");

          } else {
            $styledSelect.text($(this).text()).removeClass("active");
            $this.val($(this).attr("rel")).trigger("change");

            $list.hide();
          }
        });

        $(document).on("click", function() {
          $styledSelect.removeClass("active");
          $list.hide();
        });
      });
    }
  };

  spiralDrives.pageScroll = function() {
    // Select all links with hashes
    $(document).on("click", ".link", function(e) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        let target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          e.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top
            },
            1000,
            function() {
              // Callback after animation
              // Must change focus!
              let $target = $(target);
              $target.focus();

              if ($target.is(":focus")) {
                return false;
              } else {
                $target.attr("tabindex", "-1");
                $target.focus();
              }
            }
          );
        }
      }
    });
  };

  spiralDrives.testimonialCarousel = () => {
    let $testimonialCarousel = $(".carousel");
    $testimonialCarousel.each(function(i, e) {
      new Flickity(e, {
        pageDots: false,
        draggable: true,
        wrapAround: true,
        cellAlign: "left",
        autoPlay: 8000,
        prevNextButtons: false,
        initialIndex: ".is-initial-select"
      });
    });
  };

  spiralDrives.stickyNav = () => {
    const viewportWidth = $(window).width();

    if (viewportWidth > 768) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > 340) {
          $(".method__nav-items").addClass("sticky");
        } else {
          $(".method__nav-items").removeClass("sticky");
        }
      });
    }
    if (viewportWidth > 768) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > 400) {
          $(".faq__nav-items").addClass("sticky");
        } else {
          $(".faq__nav-items").removeClass("sticky");
        }
      });
    }
  };

  spiralDrives.init = function() {
    spiralDrives.hamburgerMenu();
    spiralDrives.subMenu();
    spiralDrives.stickyNav();
    spiralDrives.testimonialCarousel();
    spiralDrives.pageScroll();
    spiralDrives.partnersFilter();
  };

  spiralDrives.init();

  $(document).ready(function() {
    $("body").trigger("bless");
  });
})(jQuery);
